import { PaymentInformation } from "@apac/components/checkout";
import { Product } from "@b2bportal/purchase-api";
import { trackEvent } from "@hopper-b2b/api";
import { useCheckoutStateSelector } from "@hopper-b2b/checkout";
import { CHOOSE_PAYMENT } from "@hopper-b2b/types";
import { getChoosePaymentProperties } from "@hsbc/flights";

export const ConnectedPaymentInformation = ({
  disabled,
}: {
  disabled?: boolean;
}) => {
  const choosePaymentProperties = useCheckoutStateSelector(
    getChoosePaymentProperties
  );

  const onContinue = () => {
    trackEvent({
      eventName: CHOOSE_PAYMENT,
      properties: choosePaymentProperties,
    });
  };

  return (
    <PaymentInformation
      product={Product.Flight}
      disabled={disabled}
      onContinue={onContinue}
    />
  );
};
